<template>
    <div :class="['loading__wrapper', { 'loading--absolute' : absolute }]">
        <SVGacem-spinner />
    </div>
</template>

<script>
// Styles are inline in index.html so that the loader can run before the app is built.
export default {
    props: {
        absolute: {
            type: Boolean,
            default: false
        }
    }
}
</script>

